import { useState } from 'react';
import styles from './GridCell.module.css';

const NO_LAYERS = { sharedPlaces: false, hunted: false, duplicates: false };

export default function GridCell({ itemKey, label, photos, primaryPhoto, isInHuntList, isShared, layers, onClick, style }) {
  const captured = photos.length > 0;
  const thumbSrc = primaryPhoto?.thumbnailDataUrl || primaryPhoto?.thumbnailUrl || null;
  const activeLayers = layers ?? NO_LAYERS;

  // Dead-link safeguard: if the image 404s, fall back to the plain
  // (no-thumbnail) cell rendering instead of a broken-image icon.
  const [brokenSrc, setBrokenSrc] = useState(null);
  const showThumb = thumbSrc && thumbSrc !== brokenSrc;

  let cellState = 'empty';
  if (captured) cellState = 'captured';
  else if (isInHuntList) cellState = 'hunt';

  const showSharedMark = captured && isShared && activeLayers.sharedPlaces;
  const showHuntMark = captured && isInHuntList && activeLayers.hunted;
  const showDuplicateMark = captured && photos.length > 1 && activeLayers.duplicates;

  return (
    <button
      className={styles.cell}
      data-state={cellState}
      onClick={onClick}
      style={style}
      aria-label={`${label}${captured ? `, captured at ${primaryPhoto?.location}` : ', not captured'}`}
    >
      {showThumb && (
        <img
          src={thumbSrc}
          alt=""
          className={styles.thumb}
          onError={() => setBrokenSrc(thumbSrc)}
        />
      )}

      {cellState === 'captured' && <div className={styles.scrim} />}

      {cellState === 'hunt' && (
        <span className={styles.huntingLabel}>HUNTING</span>
      )}

      <span className={styles.number}>{label}</span>

      {showSharedMark && (
        <span className={styles.markShared} title="Shared location">×2</span>
      )}
      {showHuntMark && (
        <span className={styles.markHunt} title="In hunt list">HUNT</span>
      )}
      {showDuplicateMark && (
        <span className={styles.markDuplicate} title={`${photos.length - 1} extra photo${photos.length - 1 !== 1 ? 's' : ''}`}>#{photos.length - 1}</span>
      )}
    </button>
  );
}
